import {z} from '@hono/zod-openapi';

export const VoiceDebugHangupRequestSchema = z
  .object({
    schemaVersion: z.literal('1.0.0'),
    reason: z.enum(['user', 'page-closed']),
  })
  .strict()
  .openapi('VoiceDebugHangupRequestSchema');

export type VoiceDebugHangupRequest = z.infer<typeof VoiceDebugHangupRequestSchema>;
